module.exports = __webpack_public_path__ + "img/62.dfbce828.png";